export default __webpack_public_path__ + "static/media/resume.afd823f4.pdf";